import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  GET_HIGHLIGHTS_DETAILS_SUCCESS,
  GET_HIGHLIGHTS_DETAILS_ERROR,
  CLEAR_GET_HIGHLIGHTS_DETAILS,
  ADD_HIGHLIGHTS_DETAIL_SUCCESS,
  ADD_HIGHLIGHTS_DETAIL_ERROR,
  CLEAR_ADD_HIGHLIGHTS_DETAIL,
  PATCH_HIGHLIGHTS_DETAIL_SUCCESS,
  PATCH_HIGHLIGHTS_DETAIL_ERROR,
  CLEAR_PATCH_HIGHLIGHTS_DETAIL,
  DELETE_HIGHLIGHTS_DETAIL_SUCCESS,
  DELETE_HIGHLIGHTS_DETAIL_ERROR,
  DELETE_PATCH_HIGHLIGHTS_DETAIL,
} from 'redux/highlights/types';


export const fetchHighlightsDetailsList = () => baseErrorsHandlerDecorator(
  GET_HIGHLIGHTS_DETAILS_SUCCESS,
  GET_HIGHLIGHTS_DETAILS_ERROR,
  () => restapi.get(addLang('users/highlights/')),
  false,
);

export const clearFetchHighlightsDetailsList = () => dispatch => {
  dispatch({
    type: CLEAR_GET_HIGHLIGHTS_DETAILS,
  });
};

export const addHighlightsDetail = content => baseErrorsHandlerDecorator(
  ADD_HIGHLIGHTS_DETAIL_SUCCESS,
  ADD_HIGHLIGHTS_DETAIL_ERROR,
  () => restapi.post(addLang('users/highlights/'), { content }),
  false,
  true /* actionSucces */,
);

export const clearAddHighlightsDetail = () => dispatch => {
  dispatch({
    type: CLEAR_ADD_HIGHLIGHTS_DETAIL,
  });
};

export const patchHighlightsDetail = (id, formData) => baseErrorsHandlerDecorator(
  PATCH_HIGHLIGHTS_DETAIL_SUCCESS,
  PATCH_HIGHLIGHTS_DETAIL_ERROR,
  () => restapi.patch(addLang(`users/highlights/${id}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchHighlightsDetail = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_HIGHLIGHTS_DETAIL,
  });
};

export const deleteHighlightsDetail = id => baseErrorsHandlerDecorator(
  DELETE_HIGHLIGHTS_DETAIL_SUCCESS,
  DELETE_HIGHLIGHTS_DETAIL_ERROR,
  () => restapi.delete(addLang(`users/highlights/${id}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteHighlightsDetail = () => dispatch => {
  dispatch({
    type: DELETE_PATCH_HIGHLIGHTS_DETAIL,
  });
};
